import MetricPopup from './MetricPopup';

export default MetricPopup;
